<template>
    <div class="leftCardContainer">
      <div class="rightSideTitleActions">
        <span class="leftTitle">{{ $tc('Integration', 2) }}</span>
        <div class="actionsContainer">
          <div class="searchContainer">
            <v-icon> search </v-icon>
            <InputField inputType="text" :value="search" :placeholder="$t('Search')" :inputStyle="{
              borderRadius: '0px',
              width: '130px',
              borderTop: 'none',
              borderRight: 'none',
              borderLeft: 'none',
              borderBottom: '1px solid rgba(118, 118, 118, 0.50)',
            }" @input="handleSearch($event)" />
          </div>
        </div>
      </div>
      <div class="tableDivContainer">
        <Table :checkbox="false" :loading="loading" :headers="headers" :items="integrations" :sortable="true"
          @onScrollBottom="onScrollBottom" @onScrollTop="onScrollTop" @sortClick="onSortClick" :emitRowClickBusEvent="true"
        />
      </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { bus } from "@/main.js";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import ManagementPage from "@/newComponents/_Organisms/ManagementPage.vue";
import Table from "@/newComponents/_Molecules/Table.vue";
import InputField from "@/newComponents/_Atoms/InputField.vue";
import Tabs from "@/newComponents/_Atoms/Tabs.vue";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "TableView",

  mixins: [managementDatatableMixin, checkPermissionsMixin],

  components: {
    Table,
    ManagementPage,
    InputField,
    Tabs,
  },

  props: {
    selectedItem: {
      type: Object,
    },
  },

  data() {
    return {
      value: null,
      type: "normal",
      search: null,
      activeTab: 0,
      loading: false,
      scrollTop: 0,
      sortOrder: null,
      scrollHeight: 0,
      tabs: [
      ],
      pageNumber: 1,
      pagination: 25,
      currentPageTop: 1,
      currentPageBot: 1,
      lastPage: 2,
      integrations: []
    };
  },

  mounted() {
    this.getInitialIntegrations();
    bus.$on("reload-integrations", () => this.getInitialIntegrations())
  },

  destroyed() {
    bus.$off("reload-integrations");
  },

  computed: {
    headers() {
      return [
        { text: this.$i18n.tc("Label",1), varName: "name" },
        { text: this.$i18n.t("IntegrationType"), varName: "integration_type" },
        { text: this.$i18n.t("Active"), varName: "active" },
        { text: this.$i18n.t("Visible"), varName: "visible" },
        { text: this.$i18n.t("Index"), varName: "index" },
      ]
    },

  },

  methods: {
    ...mapActions(["fetchAllIntegrations"]),
    
    async getInitialIntegrations() {
      this.loading = true;
      this.currentPageBot = 1
      this.currentPageTop = 1
      let queryParams = {
        "page[number]": 1,
        paginate: 25,
      };

      if (this.search !== null) {
        queryParams["filter[search]"] = this.search;
      }

      if (this.sortOrder !== null) {
        queryParams["sort"] = this.sortOrder;
      }

      this.getIntegrations(queryParams);
    },

    getIntegrations(queryParams, scrollDirection = null) {
        this.getAllIntegrations(queryParams, scrollDirection);
    },

    async getAllIntegrations(queryParams = null, scrollDirection = null) {
      this.loading = true;
      try {
        let integrations = await this.fetchAllIntegrations(queryParams);
        this.processIntegrationsData(integrations, scrollDirection);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        this.$nextTick(() =>
          this.updateLocalPagination(this.paginationFromParent)
        );
      }
    },

    processIntegrationsData(integrationsData, scrollDirection = null) {
      let allIntegrations = null;
      let currentScroll = null;
      let rowElement = null;
      switch (scrollDirection) {
        case 'top':
          this.lastPage = integrationsData.meta.last_page;
          allIntegrations = [...integrationsData.data, ...this.integrations];
          this.integrations = Array.from(new Set(allIntegrations.map(a => a.sm_id)))
            .map(id => { return allIntegrations.find(a => a.sm_id === id) })
          if (this.integrations.length > 75) {
            this.integrations.splice(-(this.integrations.length - 75));
            this.currentPageBot--;
          }

          currentScroll = document.getElementById("scroll-bar").scrollTop;
          this.loading = false;

          rowElement = document.getElementById("rowId");
          if (rowElement) {
            const rowHeight = rowElement.clientHeight;
            for (let i = 0; i < 25; i++) {
              const offset = rowHeight * i;
              document.getElementById("scroll-bar").scrollTo({
                top: currentScroll + offset,
                behavior: "smooth",
              });
            }
          }
          break;
        case 'bottom':
          this.lastPage = integrationsData.meta.last_page;
          allIntegrations = [...this.integrations, ...integrationsData.data];
          this.integrations = Array.from(new Set(allIntegrations.map(a => a.sm_id)))
            .map(id => { return allIntegrations.find(a => a.sm_id === id) })
          if (this.integrations.length > 75) {
            this.integrations = this.integrations.slice(this.integrations.length - 75);
          }

          currentScroll = document.getElementById("scroll-bar").scrollTop;
          this.loading = false;

          rowElement = document.getElementById("rowId");
          if (rowElement) {
            const rowHeight = rowElement.clientHeight;
            for (let i = 0; i < 2; i++) {
              const offset = rowHeight * i;
              document.getElementById("scroll-bar").scrollTo({
                top: currentScroll - offset,
                behavior: "smooth",
              });
            }
          }
          break;
        default:
          this.integrations = integrationsData.data;
          this.lastPage = integrationsData.meta.last_page;
          break;
      }
      this.integrations.forEach(integration => {
        integration.active = integration.active ? 'Yes' : 'No'
        integration.visible = integration.visible ? 'Yes' : 'No'
        integration.integration_type = integration.integration_type ? integration.integration_type : '-'
      });
    },

    getIntegrationsBottom() {
        this.loading = true;
        this.pagination = 25;
        if (this.integrations.length >= 75) {
            this.currentPageTop++;
        }
        this.currentPageBot++;

        let queryParams = {
            "page[number]": this.currentPageBot,
            paginate: this.pagination,
        };

        if (this.search !== null) {
            queryParams["filter[search]"] = this.search;
        }

        if (this.sortOrder !== null) {
            queryParams["sort"] = this.sortOrder;
        }

        this.getIntegrations(queryParams, 'bottom');
    },

    async getIntegrationsTop() {
        this.loading = true;
        this.pagination = 25;
        this.currentPageTop--;

        let queryParams = {
            "page[number]": this.currentPageTop,
            paginate: this.pagination,
        };

        if (this.search !== null) {
            queryParams["filter[search]"] = this.search;
        }

        if (this.sortOrder !== null) {
            queryParams["sort"] = this.sortOrder;
        }

        this.getIntegrations(queryParams, 'top');
    },

    handleSearch: _.debounce(function (event) {
      if (event === "") {
        this.search = null;
      } else {
        this.search = event;
      }
      this.integrations = [];
      this.getInitialIntegrations();
    }, 1000),

    onScrollBottom() {
      if (this.currentPageBot !== this.lastPage) {
        this.pageNumber++;
        this.getIntegrationsBottom();
      }
    },

    onScrollTop() {
      if (this.currentPageTop !== 1) {
        this.pageNumber--;
        this.getIntegrationsTop();
      }
    },

    onSortClick(sortOrder, index) {
      this.integrations = []
      if (sortOrder === "asc") {
        this.sortOrder = this.headers[index].varName;
      } else if (sortOrder === "desc") {
        this.sortOrder = `-${this.headers[index].varName}`;
      } else {
        this.sortOrder = sortOrder;
      }
      this.getInitialIntegrations();
    },

  },
};
</script>

<style scoped>
.searchContainer {
  display: flex;
  align-items: center;
}

.tableDivContainer {
  height: 87%;
  margin-top: 5px;
}

.actionsContainer {
  display: flex;
  align-items: center;
  gap: 3px;
}

.leftTitle {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 20px;
  text-transform: uppercase;
}

.leftCardContainer {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  padding: 20px 28px;
}

.rightSideTitleActions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.layers-search .v-input__slot {
  min-height: 0 !important;
}

.layers-search .v-label {
  top: 4px !important;
  font: normal normal normal 12px/16px Segoe UI;
  color: #b1b6b9;
}

.table-custom {
  height: 90%;
}

</style>



// WEBPACK FOOTER //
// src/newComponents/Integrations/TableView.vue